import { render, staticRenderFns } from "./TransitionExpand.vue?vue&type=template&id=36f1b845&"
import script from "./TransitionExpand.vue?vue&type=script&lang=ts&"
export * from "./TransitionExpand.vue?vue&type=script&lang=ts&"
import style0 from "./TransitionExpand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports